module.exports = __webpack_public_path__ + "static/ace-217a60dac9f356b2910d3f4514eae4b9.jpg";